import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

const opts = {
  breakpoint: {
    mobileBreakpoint: 985,
    thresholds: {
      xs: 637,
      sm: 985,
      md: 1440,
    },
  },
  theme: {
    themes: {
      light: {
        primary: '#e3000b',
        secondary: '#495057',
        tertiary: '#dddddd',
        accent: '#ff7178',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
      dark: {
        primary: '#e3000b',
        secondary: '#495057',
        accent: '#FF4081',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
      },
    },
    options: { variations: false },
  },
}

export default new Vuetify(opts);
